module.exports = __webpack_public_path__ + "img/21_95.41178e9a.png";